import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

/** A break this long starts a fresh play session. */
export const SESSION_GAP_MS = 30 * 60 * 1000;

/** Levels finished in the current session after one more completion at `now`. */
export function nextSessionCount(prevCount: number, lastAt: number | null, now: number): number {
  if (lastAt == null || now - lastAt > SESSION_GAP_MS) return 1;
  return prevCount + 1;
}

/** True when the truck should "go to sleep in the garage" instead of offering another level. */
export function shouldRest(count: number, limit: number, enabled: boolean): boolean {
  return enabled && limit > 0 && count >= limit;
}

interface SessionState {
  levelsDone: number;
  lastCompletedAt: number | null;
  recordLevelComplete: (now?: number) => void;
  reset: () => void;
}

/** Per tab (sessionStorage): survives a reload, but closing the tab or a long break starts over. */
export const useSessionStore = create<SessionState>()(
  persist(
    (set, get) => ({
      levelsDone: 0,
      lastCompletedAt: null,
      recordLevelComplete: (now = Date.now()) => {
        const { levelsDone, lastCompletedAt } = get();
        set({ levelsDone: nextSessionCount(levelsDone, lastCompletedAt, now), lastCompletedAt: now });
      },
      reset: () => set({ levelsDone: 0, lastCompletedAt: null }),
    }),
    {
      name: 'enklespill:session:v1',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ levelsDone: state.levelsDone, lastCompletedAt: state.lastCompletedAt }),
    }
  )
);
